import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Button, Stack, Typography } from '@mui/material';
import QRCodeData from '../ui/grcode/qrCodeData';
import MuiLink from '@mui/material/Link';
import { Link } from 'react-router-dom';
import PoweredBy from '../ui/poweredBy';
import PoweredByBowlscout from '../ui/poweredByBowlscout';

const PrintGreensQRCodes = () => {
  const event = useSelector((state) => state.event.event);

  const handlePrint = () => {
    window.print();
  };

  return (
    <>
      <style>
        {`
          @media print {
            /* Hide everything by default */
            body * {
              visibility: hidden;
            }
            
            /* Show only the printable content */
            .printable-qr-codes,
            .printable-qr-codes * {
              visibility: visible;
            }
            
            /* Position the printable content at the top */
            .printable-qr-codes {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
            }
            
            /* Remove margins and adjust layout for print */
            .qr-code-container {
              display: flex !important;
              flex-wrap: wrap !important;
              justify-content: flex-start !important;
              gap: 20px !important;
              margin: 0 !important;
              padding: 20px !important;
            }
            
            .qr-code-item {
              break-inside: avoid;
              margin: 10px !important;
              page-break-inside: avoid;
              border: 2px solid black !important;
            }
            
            /* Ensure text is black when printing */
            .qr-code-item * {
              color: black !important;
              -webkit-print-color-adjust: exact !important;
              color-adjust: exact !important;
            }
            
            /* Hide non-essential elements */
            .no-print {
              display: none !important;
            }
          }
        `}
      </style>

      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
        className="no-print">
        <Stack>
          <MuiLink component={Link} to={`/events/${event.id}`} underline="hover">
            <Typography variant="h6" gutterBottom>
              {event.name}
            </Typography>
          </MuiLink>
          <Typography variant="h4" gutterBottom>
            Greens QR Codes
          </Typography>
        </Stack>
        <Button variant="contained" color="primary" sx={{ mb: 2 }} onClick={handlePrint}>
          Print Codes
        </Button>
      </Box>

      <Box
        display="flex"
        flexWrap="wrap"
        justifyContent="center"
        alignItems="center"
        gap={2}
        className="printable-qr-codes qr-code-container">
        {event.greens.map((green, index) => (
          <Box display={'flex'} flexWrap="wrap" key={index}>
            {green.rinks &&
              green.rinks.length > 0 &&
              green.rinks.map(
                (rink) =>
                  rink.active && (
                    <Box
                      display={'flex'}
                      sx={{ border: '2px solid', borderColor: 'primary.main' }}
                      m={1}
                      p={2}
                      justifyContent="center"
                      alignItems="center"
                      flexDirection="column"
                      key={`${green.name}-${rink.rink}`}
                      className="qr-code-item">
                      <Typography variant="h4" gutterBottom>
                        {`${green.name}${rink.rink}`}
                      </Typography>
                      <Box>
                        <QRCodeData
                          value={`https://bowlscout.co.za/public/scoring/${event.id}/${green.name}${rink.rink}`}
                          style={{ width: '150px', height: '150px' }}
                        />
                      </Box>
                      <MuiLink
                        component={Link}
                        to={`/public/scoring/${event.id}/${green.name}${rink.rink}`}
                        target="_blank"
                        className="no-print">
                        <Typography variant="body1" color="primary">
                          View Game
                        </Typography>
                      </MuiLink>

                      <PoweredBy overrideMode={'light'} />
                    </Box>
                  )
              )}
          </Box>
        ))}
      </Box>
    </>
  );
};

export default PrintGreensQRCodes;
